import {BaseService, Body, GET, POST, Headers, Path, Response} from 'ts-retrofit';
import {ACCEPT_JSON} from '../../config';
import {ToData} from '../../rest-api-hydratator-decorators';
import {Movie} from '../../../../models/vision/movie';

const base = 'carousel';

export class CarouselApiService extends BaseService {
  @GET(`/${base}`)
  @Headers({...ACCEPT_JSON})
  @ToData(Movie)
  async getCarouselMovies(): Promise<Response<Movie[]>> {
    return <Response>{};
  }

  @POST(`/${base}`)
  @Headers({...ACCEPT_JSON})
  async saveCarouselSequence(@Body movieIds: number[]): Promise<Response<boolean>> {
    return <Response>{};
  }
}
